import React from 'react';
import { ModalStyled } from './styled';
import cx from 'classnames';

export const Modal = ({
  theme_modal_standard,
  theme_modal_border,
  children,
  isShow,
  handleClickCloseModal,
}) => {
  const customClass = cx({
    theme_modal_standard: theme_modal_standard,
    theme_modal_border: theme_modal_border,
  });

  return (
    <ModalStyled _isShow={isShow}>
      <div className={customClass}>
        <div className="modal_body">{children}</div>
        <div className="backdrop" onClick={handleClickCloseModal} />
      </div>
    </ModalStyled>
  );
};
